/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './user-additional-history.reducer';

export const UserAdditionalHistory = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const userAdditionalHistoryList = useAppSelector(state => state.userAdditionalHistory.entities);
  const loading = useAppSelector(state => state.userAdditionalHistory.loading);
  const totalItems = useAppSelector(state => state.userAdditionalHistory.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="user-additional-history-heading" data-cy="UserAdditionalHistoryHeading">
        <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.home.title">User Additional Histories</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link
            to="/user-additional-history/new"
            className="btn btn-primary jh-create-entity"
            id="jh-create-entity"
            data-cy="entityCreateButton"
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.home.createLabel">Create new User Additional History</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.userAdditionalHistory.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {userAdditionalHistoryList && userAdditionalHistoryList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('coffee')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.coffee">Coffee</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('coffee')} />
                </th>
                <th className="hand" onClick={sort('tobacco')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.tobacco">Tobacco</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('tobacco')} />
                </th>
                <th className="hand" onClick={sort('alcohol')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.alcohol">Alcohol</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('alcohol')} />
                </th>
                <th className="hand" onClick={sort('sleepPatterns')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.sleepPatterns">Sleep Patterns</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('sleepPatterns')} />
                </th>
                <th className="hand" onClick={sort('exercisePatterns')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.exercisePatterns">Exercise Patterns</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('exercisePatterns')} />
                </th>
                <th className="hand" onClick={sort('seatbeltUse')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.seatbeltUse">Seatbelt Use</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('seatbeltUse')} />
                </th>
                <th className="hand" onClick={sort('counseling')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.counseling">Counseling</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('counseling')} />
                </th>
                <th className="hand" onClick={sort('hazardousActivities')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.hazardousActivities">Hazardous Activities</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('hazardousActivities')} />
                </th>
                <th className="hand" onClick={sort('recreationalDrugs')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.recreationalDrugs">Recreational Drugs</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('recreationalDrugs')} />
                </th>
                <th className="hand" onClick={sort('recentBreastExam')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.recentBreastExam">Recent Breast Exam</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('recentBreastExam')} />
                </th>
                <th className="hand" onClick={sort('recentMammogram')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.recentMammogram">Recent Mammogram</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('recentMammogram')} />
                </th>
                <th className="hand" onClick={sort('recentGynocologicalExam')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.recentGynocologicalExam">
                    Recent Gynocological Exam
                  </Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('recentGynocologicalExam')} />
                </th>
                <th className="hand" onClick={sort('recentRectalExam')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.recentRectalExam">Recent Rectal Exam</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('recentRectalExam')} />
                </th>
                <th className="hand" onClick={sort('recentProstateExam')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.recentProstateExam">Recent Prostate Exam</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('recentProstateExam')} />
                </th>
                <th className="hand" onClick={sort('recentPhysicalExam')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.recentPhysicalExam">Recent Physical Exam</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('recentPhysicalExam')} />
                </th>
                <th className="hand" onClick={sort('recentSigmoidoscopyColonoscopy')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.recentSigmoidoscopyColonoscopy">
                    Recent Sigmoidoscopy Colonoscopy
                  </Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('recentSigmoidoscopyColonoscopy')} />
                </th>
                <th className="hand" onClick={sort('recentEcg')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.recentEcg">Recent Ecg</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('recentEcg')} />
                </th>
                <th className="hand" onClick={sort('recentCardiacEcho')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.recentCardiacEcho">Recent Cardiac Echo</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('recentCardiacEcho')} />
                </th>
                <th className="hand" onClick={sort('recentRetinal')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.recentRetinal">Recent Retinal</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('recentRetinal')} />
                </th>
                <th className="hand" onClick={sort('recentFluvax')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.recentFluvax">Recent Fluvax</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('recentFluvax')} />
                </th>
                <th className="hand" onClick={sort('recentPneuvax')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.recentPneuvax">Recent Pneuvax</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('recentPneuvax')} />
                </th>
                <th className="hand" onClick={sort('recentLdl')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.recentLdl">Recent Ldl</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('recentLdl')} />
                </th>
                <th className="hand" onClick={sort('recentHemoglobin')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.recentHemoglobin">Recent Hemoglobin</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('recentHemoglobin')} />
                </th>
                <th className="hand" onClick={sort('recentPsa')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.recentPsa">Recent Psa</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('recentPsa')} />
                </th>
                <th className="hand" onClick={sort('recentExamResults')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.recentExamResults">Recent Exam Results</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('recentExamResults')} />
                </th>
                <th className="hand" onClick={sort('historyMother')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.historyMother">History Mother</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('historyMother')} />
                </th>
                <th className="hand" onClick={sort('dcMother')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.dcMother">Dc Mother</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('dcMother')} />
                </th>
                <th className="hand" onClick={sort('historyFather')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.historyFather">History Father</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('historyFather')} />
                </th>
                <th className="hand" onClick={sort('dcFather')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.dcFather">Dc Father</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('dcFather')} />
                </th>
                <th className="hand" onClick={sort('historySiblings')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.historySiblings">History Siblings</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('historySiblings')} />
                </th>
                <th className="hand" onClick={sort('dcSiblings')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.dcSiblings">Dc Siblings</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('dcSiblings')} />
                </th>
                <th className="hand" onClick={sort('historyOffspring')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.historyOffspring">History Offspring</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('historyOffspring')} />
                </th>
                <th className="hand" onClick={sort('dcOffspring')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.dcOffspring">Dc Offspring</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('dcOffspring')} />
                </th>
                <th className="hand" onClick={sort('historySpouse')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.historySpouse">History Spouse</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('historySpouse')} />
                </th>
                <th className="hand" onClick={sort('dcSpouse')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.dcSpouse">Dc Spouse</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('dcSpouse')} />
                </th>
                <th className="hand" onClick={sort('relativesCancer')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.relativesCancer">Relatives Cancer</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('relativesCancer')} />
                </th>
                <th className="hand" onClick={sort('relativesTuberculosis')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.relativesTuberculosis">Relatives Tuberculosis</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('relativesTuberculosis')} />
                </th>
                <th className="hand" onClick={sort('relativesDiabetes')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.relativesDiabetes">Relatives Diabetes</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('relativesDiabetes')} />
                </th>
                <th className="hand" onClick={sort('relativesHighBloodPressure')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.relativesHighBloodPressure">
                    Relatives High Blood Pressure
                  </Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('relativesHighBloodPressure')} />
                </th>
                <th className="hand" onClick={sort('relativesHeartProblems')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.relativesHeartProblems">Relatives Heart Problems</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('relativesHeartProblems')} />
                </th>
                <th className="hand" onClick={sort('relativesStroke')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.relativesStroke">Relatives Stroke</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('relativesStroke')} />
                </th>
                <th className="hand" onClick={sort('relativesEpilepsy')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.relativesEpilepsy">Relatives Epilepsy</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('relativesEpilepsy')} />
                </th>
                <th className="hand" onClick={sort('relativesMentalIllness')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.relativesMentalIllness">Relatives Mental Illness</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('relativesMentalIllness')} />
                </th>
                <th className="hand" onClick={sort('relativesSuicide')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.relativesSuicide">Relatives Suicide</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('relativesSuicide')} />
                </th>
                <th className="hand" onClick={sort('cataractSurgery')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.cataractSurgery">Cataract Surgery</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cataractSurgery')} />
                </th>
                <th className="hand" onClick={sort('tonsillectomy')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.tonsillectomy">Tonsillectomy</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('tonsillectomy')} />
                </th>
                <th className="hand" onClick={sort('cholecystestomy')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.cholecystestomy">Cholecystestomy</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cholecystestomy')} />
                </th>
                <th className="hand" onClick={sort('heartSurgery')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.heartSurgery">Heart Surgery</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('heartSurgery')} />
                </th>
                <th className="hand" onClick={sort('hysterectomy')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.hysterectomy">Hysterectomy</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('hysterectomy')} />
                </th>
                <th className="hand" onClick={sort('herniaRepair')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.herniaRepair">Hernia Repair</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('herniaRepair')} />
                </th>
                <th className="hand" onClick={sort('hipReplacement')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.hipReplacement">Hip Replacement</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('hipReplacement')} />
                </th>
                <th className="hand" onClick={sort('kneeReplacement')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.kneeReplacement">Knee Replacement</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('kneeReplacement')} />
                </th>
                <th className="hand" onClick={sort('appendectomy')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.appendectomy">Appendectomy</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('appendectomy')} />
                </th>
                <th className="hand" onClick={sort('tmDate')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.tmDate">Tm Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('tmDate')} />
                </th>
                <th className="hand" onClick={sort('name1')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.name1">Name 1</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('name1')} />
                </th>
                <th className="hand" onClick={sort('value1')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.value1">Value 1</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('value1')} />
                </th>
                <th className="hand" onClick={sort('name2')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.name2">Name 2</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('name2')} />
                </th>
                <th className="hand" onClick={sort('value2')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.value2">Value 2</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('value2')} />
                </th>
                <th className="hand" onClick={sort('additionalHistory')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.additionalHistory">Additional History</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('additionalHistory')} />
                </th>
                <th className="hand" onClick={sort('exams')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.exams">Exams</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('exams')} />
                </th>
                <th className="hand" onClick={sort('usertext11')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.usertext11">Usertext 11</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('usertext11')} />
                </th>
                <th className="hand" onClick={sort('usertext12')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.usertext12">Usertext 12</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('usertext12')} />
                </th>
                <th className="hand" onClick={sort('usertext13')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.usertext13">Usertext 13</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('usertext13')} />
                </th>
                <th className="hand" onClick={sort('usertext14')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.usertext14">Usertext 14</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('usertext14')} />
                </th>
                <th className="hand" onClick={sort('usertext15')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.usertext15">Usertext 15</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('usertext15')} />
                </th>
                <th className="hand" onClick={sort('usertext16')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.usertext16">Usertext 16</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('usertext16')} />
                </th>
                <th className="hand" onClick={sort('usertext17')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.usertext17">Usertext 17</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('usertext17')} />
                </th>
                <th className="hand" onClick={sort('usertext18')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.usertext18">Usertext 18</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('usertext18')} />
                </th>
                <th className="hand" onClick={sort('usertext19')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.usertext19">Usertext 19</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('usertext19')} />
                </th>
                <th className="hand" onClick={sort('usertext20')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.usertext20">Usertext 20</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('usertext20')} />
                </th>
                <th className="hand" onClick={sort('usertext21')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.usertext21">Usertext 21</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('usertext21')} />
                </th>
                <th className="hand" onClick={sort('usertext22')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.usertext22">Usertext 22</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('usertext22')} />
                </th>
                <th className="hand" onClick={sort('usertext23')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.usertext23">Usertext 23</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('usertext23')} />
                </th>
                <th className="hand" onClick={sort('usertext24')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.usertext24">Usertext 24</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('usertext24')} />
                </th>
                <th className="hand" onClick={sort('usertext25')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.usertext25">Usertext 25</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('usertext25')} />
                </th>
                <th className="hand" onClick={sort('usertext26')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.usertext26">Usertext 26</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('usertext26')} />
                </th>
                <th className="hand" onClick={sort('usertext27')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.usertext27">Usertext 27</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('usertext27')} />
                </th>
                <th className="hand" onClick={sort('usertext28')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.usertext28">Usertext 28</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('usertext28')} />
                </th>
                <th className="hand" onClick={sort('usertext29')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.usertext29">Usertext 29</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('usertext29')} />
                </th>
                <th className="hand" onClick={sort('usertext30')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.usertext30">Usertext 30</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('usertext30')} />
                </th>
                <th className="hand" onClick={sort('userdate11')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.userdate11">Userdate 11</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('userdate11')} />
                </th>
                <th className="hand" onClick={sort('userdate12')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.userdate12">Userdate 12</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('userdate12')} />
                </th>
                <th className="hand" onClick={sort('userdate13')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.userdate13">Userdate 13</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('userdate13')} />
                </th>
                <th className="hand" onClick={sort('userdate14')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.userdate14">Userdate 14</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('userdate14')} />
                </th>
                <th className="hand" onClick={sort('userdate15')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.userdate15">Userdate 15</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('userdate15')} />
                </th>
                <th className="hand" onClick={sort('userarea11')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.userarea11">Userarea 11</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('userarea11')} />
                </th>
                <th className="hand" onClick={sort('userarea12')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.userarea12">Userarea 12</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('userarea12')} />
                </th>
                <th className="hand" onClick={sort('timestampentry')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.timestampentry">Timestampentry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampentry')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('lastupdated')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.lastupdated">Lastupdated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastupdated')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.consultant">Consultant</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.glucoUser">Gluco User</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {userAdditionalHistoryList.map((userAdditionalHistory, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/user-additional-history/${userAdditionalHistory.id}`} color="link" size="sm">
                      {userAdditionalHistory.id}
                    </Button>
                  </td>
                  <td>{userAdditionalHistory.coffee}</td>
                  <td>{userAdditionalHistory.tobacco}</td>
                  <td>{userAdditionalHistory.alcohol}</td>
                  <td>{userAdditionalHistory.sleepPatterns}</td>
                  <td>{userAdditionalHistory.exercisePatterns}</td>
                  <td>{userAdditionalHistory.seatbeltUse}</td>
                  <td>{userAdditionalHistory.counseling}</td>
                  <td>{userAdditionalHistory.hazardousActivities}</td>
                  <td>{userAdditionalHistory.recreationalDrugs}</td>
                  <td>{userAdditionalHistory.recentBreastExam}</td>
                  <td>{userAdditionalHistory.recentMammogram}</td>
                  <td>{userAdditionalHistory.recentGynocologicalExam}</td>
                  <td>{userAdditionalHistory.recentRectalExam}</td>
                  <td>{userAdditionalHistory.recentProstateExam}</td>
                  <td>{userAdditionalHistory.recentPhysicalExam}</td>
                  <td>{userAdditionalHistory.recentSigmoidoscopyColonoscopy}</td>
                  <td>{userAdditionalHistory.recentEcg}</td>
                  <td>{userAdditionalHistory.recentCardiacEcho}</td>
                  <td>{userAdditionalHistory.recentRetinal}</td>
                  <td>{userAdditionalHistory.recentFluvax}</td>
                  <td>{userAdditionalHistory.recentPneuvax}</td>
                  <td>{userAdditionalHistory.recentLdl}</td>
                  <td>{userAdditionalHistory.recentHemoglobin}</td>
                  <td>{userAdditionalHistory.recentPsa}</td>
                  <td>{userAdditionalHistory.recentExamResults}</td>
                  <td>{userAdditionalHistory.historyMother}</td>
                  <td>{userAdditionalHistory.dcMother}</td>
                  <td>{userAdditionalHistory.historyFather}</td>
                  <td>{userAdditionalHistory.dcFather}</td>
                  <td>{userAdditionalHistory.historySiblings}</td>
                  <td>{userAdditionalHistory.dcSiblings}</td>
                  <td>{userAdditionalHistory.historyOffspring}</td>
                  <td>{userAdditionalHistory.dcOffspring}</td>
                  <td>{userAdditionalHistory.historySpouse}</td>
                  <td>{userAdditionalHistory.dcSpouse}</td>
                  <td>{userAdditionalHistory.relativesCancer}</td>
                  <td>{userAdditionalHistory.relativesTuberculosis}</td>
                  <td>{userAdditionalHistory.relativesDiabetes}</td>
                  <td>{userAdditionalHistory.relativesHighBloodPressure}</td>
                  <td>{userAdditionalHistory.relativesHeartProblems}</td>
                  <td>{userAdditionalHistory.relativesStroke}</td>
                  <td>{userAdditionalHistory.relativesEpilepsy}</td>
                  <td>{userAdditionalHistory.relativesMentalIllness}</td>
                  <td>{userAdditionalHistory.relativesSuicide}</td>
                  <td>{userAdditionalHistory.cataractSurgery}</td>
                  <td>{userAdditionalHistory.tonsillectomy}</td>
                  <td>{userAdditionalHistory.cholecystestomy}</td>
                  <td>{userAdditionalHistory.heartSurgery}</td>
                  <td>{userAdditionalHistory.hysterectomy}</td>
                  <td>{userAdditionalHistory.herniaRepair}</td>
                  <td>{userAdditionalHistory.hipReplacement}</td>
                  <td>{userAdditionalHistory.kneeReplacement}</td>
                  <td>{userAdditionalHistory.appendectomy}</td>
                  <td>{userAdditionalHistory.tmDate}</td>
                  <td>{userAdditionalHistory.name1}</td>
                  <td>{userAdditionalHistory.value1}</td>
                  <td>{userAdditionalHistory.name2}</td>
                  <td>{userAdditionalHistory.value2}</td>
                  <td>{userAdditionalHistory.additionalHistory}</td>
                  <td>{userAdditionalHistory.exams}</td>
                  <td>{userAdditionalHistory.usertext11}</td>
                  <td>{userAdditionalHistory.usertext12}</td>
                  <td>{userAdditionalHistory.usertext13}</td>
                  <td>{userAdditionalHistory.usertext14}</td>
                  <td>{userAdditionalHistory.usertext15}</td>
                  <td>{userAdditionalHistory.usertext16}</td>
                  <td>{userAdditionalHistory.usertext17}</td>
                  <td>{userAdditionalHistory.usertext18}</td>
                  <td>{userAdditionalHistory.usertext19}</td>
                  <td>{userAdditionalHistory.usertext20}</td>
                  <td>{userAdditionalHistory.usertext21}</td>
                  <td>{userAdditionalHistory.usertext22}</td>
                  <td>{userAdditionalHistory.usertext23}</td>
                  <td>{userAdditionalHistory.usertext24}</td>
                  <td>{userAdditionalHistory.usertext25}</td>
                  <td>{userAdditionalHistory.usertext26}</td>
                  <td>{userAdditionalHistory.usertext27}</td>
                  <td>{userAdditionalHistory.usertext28}</td>
                  <td>{userAdditionalHistory.usertext29}</td>
                  <td>{userAdditionalHistory.usertext30}</td>
                  <td>{userAdditionalHistory.userdate11}</td>
                  <td>{userAdditionalHistory.userdate12}</td>
                  <td>{userAdditionalHistory.userdate13}</td>
                  <td>{userAdditionalHistory.userdate14}</td>
                  <td>{userAdditionalHistory.userdate15}</td>
                  <td>{userAdditionalHistory.userarea11}</td>
                  <td>{userAdditionalHistory.userarea12}</td>
                  <td>{userAdditionalHistory.timestampentry}</td>
                  <td>{userAdditionalHistory.active ? 'true' : 'false'}</td>
                  <td>{userAdditionalHistory.lastupdated}</td>
                  <td>{userAdditionalHistory.cursor}</td>
                  <td>{userAdditionalHistory.microSec}</td>
                  <td>
                    {userAdditionalHistory.consultant ? (
                      <Link to={`/doctor/${userAdditionalHistory.consultant.id}`}>{userAdditionalHistory.consultant.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {userAdditionalHistory.glucoUser ? (
                      <Link to={`/gluco-user/${userAdditionalHistory.glucoUser.id}`}>{userAdditionalHistory.glucoUser.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/user-additional-history/${userAdditionalHistory.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/user-additional-history/${userAdditionalHistory.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/user-additional-history/${userAdditionalHistory.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.home.notFound">No User Additional Histories found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={userAdditionalHistoryList && userAdditionalHistoryList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default UserAdditionalHistory;
